export default {
  session: {
    auth: false,
    token: undefined,
  },
};
